module.exports = __webpack_public_path__ + "img/ricelog_pinicon_063.78bf5151.png";